import React from "react";
import { motion } from "framer-motion";
import EApi from "../../../api/esports";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";

const spotlight = {
  from: (num = 1) => ({
    originX: num === 1 ? "0%" : "100%",
    x: num === 1 ? "-100%" : "100%",
    y: 0,
    opacity: 0
  }),
  to: (num = 1) => ({
    x: 0,
    y: [num === 1 ? 4 : -4, num === 1 ? 4 : -4, num === 1 ? 4 : -4, 0],
    opacity: 1
  })
};

const spotlightBg = {
  from: (num = 1) => ({
    originX: num === 1 ? "0%" : "100%",
    scaleX: 1
  }),
  to: {
    scaleX: 0.8,
    transition: {
      delay: 0.5
    }
  }
};

const spotlightVs = {
  from: {
    opacity: 0,
    scale: 0,
    transition: {
      delay: 0
    }
  },
  to: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0.6
    }
  }
};

class Spotlight extends React.Component {
  render() {
    const { eventId, team1, team2, cf1, cf2, logo1, logo2 } = this.props;

    return (
      <NavLink className="spotlight" exact to={`/esports/${eventId}`}>
        <motion.div
          className="spotlight__team"
          variants={spotlight}

          custom={1}
        >
          <div className="spotlight__team-top">
            <div className="spotlight__logo">
              <img src={logo1} />
            </div>
            <div className="spotlight__title">{team1}</div>
          </div>
          <motion.div
            className="spotlight__bg"
            variants={spotlightBg}

            custom={1}
          />
          <div className="spotlight__cf">{cf1}</div>
        </motion.div>
        <div className="spotlight__vs">
          <motion.div
            variants={spotlightVs}

          />
        </div>
        <motion.div
          className="spotlight__team"
          variants={spotlight}

          custom={2}
        >
          <div className="spotlight__team-top">
            <div className="spotlight__logo">
              <img src={logo2} />
            </div>
            <div className="spotlight__title">{team2}</div>
          </div>
          <motion.div
            className="spotlight__bg"
            variants={spotlightBg}

            custom={2}
          />
          <div className="spotlight__cf">{cf2}</div>
        </motion.div>
      </NavLink>
    );
  }
}

export class SpotlightList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      events: []
    };

    this.timer = null;
    this.requests = [];
  }

  componentDidMount() {
    clearInterval(this.timer);
    if (!this.props.isLoading) {
      this.loadSpotlights();
    }

    this.timer = setInterval(this.loadSpotlights, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.requests.forEach(cancel => cancel());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoading && !this.props.isLoading) {
      this.loadSpotlights();
    }
  }

  loadSpotlights = () => {
    EApi.loadSpotlights().then((response) => {
      if (response.status === "success") {
        this.setState({ events: response.events });
      }
    });
  };

  render() {
    const { events } = this.state;

    const list = {
      from: {
        opacity: 0,
        transition: { staggerChildren: 0, when: "beforeChildren" }
      },
      to: {
        opacity: 1,
        transition: { staggerChildren: 0.1 }
      }
    };

    if (!events.length) return null;


    return (
      <Scrollbars hideTracksWhenNotNeeded={true}>
        <motion.div
          className="spotlight-list"
          initial={"from"}
          animate={"to"}
          variants={list}
        >
          {events.map(event => (
            <motion.div key={event["id"]} initial={"from"} animate={"to"}>
              <Spotlight
                eventId={event["id"]}
                logo1={`/img/logo/${event["logo_ht"]}`}
                logo2={`/img/logo/${event["logo_at"]}`}
                team1={event["name_ht"]}
                team2={event["name_at"]}
                cf1={event["cf_ht"]}
                cf2={event["cf_at"]}
              />
            </motion.div>
          ))}

        </motion.div>
      </Scrollbars>
    );
  }
}

export default connect(state => {
  return {
    isLoading: state.user.isLoading,
    route: state.router.location.pathname
  };
}, {})(SpotlightList);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/Spotlight/Spotlight.jsx